import Swiper from 'swiper/bundle';

jQuery(document).ready(function ($) {
  new Swiper('.image-textbox-slider__slider', {
    // Optional parameters
    direction: 'horizontal',
    loop: false,
    spaceBetween: 20,
    pagination: {
      el: '.image-textbox-slider__pagination',
      clickable: true,
      bulletClass: 'image-textbox-slider__bullet',
      bulletActiveClass: 'image-textbox-slider__bullet-active',
      type: 'custom',
      renderCustom: function(swiper, current, total) {
        var jsonString = atob($(".image-textbox-slider__pagination").data("sliderData"));
        var data = JSON.parse(jsonString);

        let text = '';
        for (let i = 1; i <= total; i++) {
          const className = 'image-textbox-slider__bullet' + (i === current ? ' active' : '');
          text += '<div class="' + className + '">' + data[i - 1] + '</div>';
        }
        return text;
      }
    },
  });
});